import { ui } from '@/constants';
import { getCountryByHostname } from '@/helpers';
import { Routes } from '@/router';
import { NutritionLinkClickEvent } from '@/services/analytics/events';
import { NutritionLinkClickType } from '@/services/analytics/platforms/adobe-analytics/models';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgNutritionCalculatorIngredientsBanner',
})
export default class CmgNutritionCalculatorIngredientsBanner extends Vue {

  get countryCode(): string {
    return this.$appStore.state.ui.countryProfile.countryCode;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth < ui.breakpoints.tablet;
  }

  get ingredientsBannerUrl(): string | undefined {
    const banner = this.$appStore.state.cms.images.nutritionCalculator.ingredientsBanner;
    return this.isMobile ? banner.mobile : banner.desktop;
  }

  get forRealImageUrl(): string | undefined {
    const image = this.$appStore.state.cms.images.nutritionCalculator.forRealImage;
    return this.isMobile ? image.mobile : image.desktop;
  }
  
  get realImageUrl(): string | undefined {
    const image = this.$appStore.state.cms.images.nutritionCalculator.realImage;
    return this.isMobile ? image.mobile : image.desktop;
  }

  get isCanadaOrUK(): boolean {
    return this.countryCode === 'CA' || this.countryCode === 'GB';
  }

  onClickViewAll() {
    this.$router.push({ name: Routes.IngredientsLandingPage });
    
    this.$services.analytics.send(new NutritionLinkClickEvent(NutritionLinkClickType.ViewAllIngredients));
  }
}
